import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Md5 } from 'ts-md5/dist/md5';
import { UsuarioModel } from '../../shared/models/usuario';
import { AuthService } from '../../shared/servicios/auth.service';

@Component({
  selector: 'app-login2',
  templateUrl: './login2.component.html',
  styleUrls: ['./login2.component.scss']
})
export class Login2Component implements OnInit {

  loginForm;
  error: string;

  constructor(private auth: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      usuario: new FormControl('', [Validators.required]),
      psw: new FormControl('', [Validators.required]),
      recordarme: new FormControl(false),
    });

    if (this.auth.leerToken()) {
      this.router.navigateByUrl('/dashboard');
    }

    if (localStorage.getItem('user')) {
      this.loginForm.patchValue({
        usuario: localStorage.getItem('user'),
        recordarme: true,
      });
    }
  }

  get usuario() { return this.loginForm.get('usuario'); }

  get psw() { return this.loginForm.get('psw'); }

  setObjectUserLogin(valueForm: UsuarioModel): UsuarioModel {
    return {
      usuario: valueForm.usuario,
      psw: valueForm.psw,
    };
  }

  send() {

    const valueForm: any = { ...this.loginForm.value, };
    const usuario = this.setObjectUserLogin(valueForm);

    const password = Md5.hashStr(usuario.psw);
    usuario.psw = password.toString();
    const recordar = (this.loginForm.value.recordarme);

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...',
    });
    Swal.showLoading();

    this.auth.login(usuario, true).subscribe(resp => {
      // console.log(resp);
      if (resp[0].key !== 'Error') {
        if (recordar) {
          localStorage.setItem('user', usuario.usuario);
        } else if (!recordar) {
          localStorage.removeItem('user');
        }
        Swal.close();
        this.router.navigateByUrl('/dashboard');
      }
    }, (err) => {
      this.error = err;
      const msg = this.error.toString();
      if (msg.includes('no existe') || msg.includes('incorrecta')) {
        Swal.fire({
          icon: 'error',
          title: 'Error al autenticar',
          text: 'Usuario o Contraseña incorrecta',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al autenticar',
          text: err,
        });
      }
    });

    /*console.log("usuario:", this.loginForm.value.user);
    console.log("contraseña:", this.loginForm.value.pass);
    console.log("este es el valor", typeof this.loginForm.value.pass);
    console.log("este es el valor", Md5.hashStr(this.loginForm.value.pass));*/
    this.loginForm.reset();
  }

}
